// 消息管理
import { Request } from '@/http/request'

//  当面付 
export function faceToAlipay(parameter: any) {
  return Request.axiosInstance.post('/web/pay/face-to-alipay',parameter)
}

export default { faceToAlipay }